<template>
  <div class="upload-image"  v-loading="loading">
    <el-upload
      action=""
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :multiple="false"
      :accept="accept"
      :limit="limit"
      :file-list="fileList"
      :http-request="uploadHandle"
      :before-upload="beforeUploadHandle"
      :on-remove="handleRemove"
      :on-success="successHandle"
      :on-error="errHandle"
      :on-progress="progressHandle"
      :on-exceed="exceedHandle"
      :disabled="disabled"
      >
      <i class="el-icon-loading" v-if="isLoading" />
      <i class="el-icon-plus" v-else></i>
      <span>{{option.text}}</span>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import ImageCompressor from 'image-compressor.js'
import pdfJpg from '../../public/pdf.jpg'
import commonApi from '@/api/v2/common'
import axios from 'axios'

export default {
  props: {
    limit: {
      type: Number,
      default: 10
    },
    quality: {
      type: Number,
      default: 0.5
    },
    passSize: {
      type: Number,
      default: 5 * 1024 * 1024 // 5M
    },
    option: {
      type: Object,
      default () {
        return {
          domID: '',
          text: ''
        }
      }
    },
    imageList: {
      type: Array,
      default: () => []
    },
    business: {
      type: String,
      default: 'bucketBank'
    }
  },
  computed: {
    accept () {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        // 移动端
        return 'image/*'
      } else {
        // pc端
        return 'image/*,application/pdf'
      }
    }
  },
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      pdfUrl: '',
      pdfName: '',
      disabled: false,
      isLoading: false,
      loading: false,
      fileNameList: []
    }
  },
  watch: {
    imageList (value) {
      if (this.imageList.length > 0) {
        this.initImageView()
      }
    }
  },
  methods: {
    // 如果传入imageKeys，拉取S3图片内容显示
    async initImageView () {
      this.loading = true
      this.changButtonStyle(false)
      // let res = await this.requestImages()
      // this.fileList = this.getImageList(res)
      this.fileList.forEach(item => this.showPdf(item))
      this.loading = false
    },
    showPdf (file) {
      if (file.raw.type === 'application/pdf') {
        // 如果是pdf把背景图设置为pdf
        file.OriginUrl = file.url
        file.url = pdfJpg
      }
    },
    changButtonStyle (flag) {
      let domID = this.option.domID
      if (domID) {
        let uploadDom = document.querySelector(`#${domID} .el-upload`)
        uploadDom.style.display = flag ? 'flex' : 'none'
      }
    },
    getImageList (data) {
      return data.map(item => {
        return {
          url: this.jiema(item.data.Body.data, item.data.ContentType),
          OriginUrl: this.jiema(item.data.Body.data, item.data.ContentType),
          raw: {
            type: item.data.ContentType
          }
        }
      })
    },
    // 二进制图片转base64
    jiema (bytes, type) {
      var bString = ''
      for (var i = 0, len = bytes.length; i < len; ++i) {
        bString += String.fromCharCode(bytes[i])
      }
      return `data:${type};base64,${btoa(bString)}`
    },
    // async requestImages () {
    //   let requestArr = []
    //   for (let val of this.imageList) {
    //     requestArr.push(this.$api.getImage(val))
    //   }
    //   let res = await Promise.all(requestArr)
    //   return res
    // },
    handleRemove (file, fileList) {
      let index = this.fileList.findIndex(item => file.uid === item.uid)
      if (index >= 0) {
        this.fileList.splice(index, 1)
        this.fileNameList.splice(index, 1)
        this.$emit('handleRemove', index)
      }
      this.changButtonStyle(true)
    },
    handlePictureCardPreview (file) {
      if (file.raw.type === 'application/pdf') {
        let link = document.createElement('a')
        link.download = 'resource'
        link.href = file.OriginUrl
        link.click()
      } else {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      }
    },
    async uploadHandle (obj) {
      try {
        this.isLoading = true
        this.disabled = true
        let file = obj.file
        let fileType = file.type
        let params = {
          business: this.business, // 业务类型
          contentType: fileType || 'application/octet-stream', // 文件类型
          fileSize: file.size // 文件大小
        }
        let { data } = await commonApi.uploadOss(params)
        let config = {
          headers: {
            'Content-Type': fileType || 'application/octet-stream',
            'Content-Disposition': 'attachment;filename="' + encodeURIComponent(file.name) + '"'
          }
        }
        axios.put(data.signUrl, file, config).then(res => {
          if (res.status === 200) {
            this.isLoading = false
            const demoImageList = []
            demoImageList.push(data.temporaryUrl)
            this.fileNameList.push(data.fileName)
            this.$emit('uploadHandle', this.fileNameList, demoImageList)
          } else {
            this.isLoading = false
            this.$message.error(this.$t('common.upload.uploadFail'))
          }
        }).catch(e => {
          this.isLoading = false
          this.$message.error(this.$t('common.upload.uploadFail'))
        })
      } catch (err) {
        throw err
      }
    },
    uploadOpt () {
      return {
        'application/pdf': async (file, fileType) => {
          // 转base64
          let result = await this.blobToDataURL(file)
          // 上传图片
          let imageKey = await this.uploadFileAliSDK(result, fileType)
          console.log(imageKey)
          return imageKey
        },
        default: async (file, fileType) => {
          // 压缩
          let compressResult = await this.ImageCompressor(file)
          // 转base64
          let result = await this.blobToDataURL(compressResult)
          // 上传图片
          let imageKey = await this.uploadFileAliSDK(result, fileType)
          return imageKey
        }
      }
    },
    beforeUploadHandle (file) {
      console.log(file)
      // 限制文件大小
      if (this.passSize < file.size) {
        this.$message.error(this.$t('common.upload.limitSize', [this.passSize / (1024 * 1024)]))
        return false
      }
    },
    successHandle (response, file, fileList) {
      this.isLoading = false
      this.disabled = false
      console.log(response, file, fileList)
      if (file.raw.type === 'application/pdf') {
        // 如果是pdf把背景图设置为pdf
        file.OriginUrl = file.url
        file.url = pdfJpg
      }
      this.fileList.push(file)

      // 如果有domID就隐藏按钮
      this.changButtonStyle(false)
    },
    // eslint-disable-next-line handle-callback-err
    errHandle (err, file, fileList) {
      this.isLoading = false
      this.disabled = false
      this.$emit('errHandle')
      console.log('upload--err>>>', err)
      this.$message.error(this.$t('common.upload.uploadFail'))
    },
    progressHandle (event, file, fileList) {
      this.$emit('progressHandle')
    },
    exceedHandle (files, fileList) {
      this.$message.error(this.$t('common.upload.limitNumber', [this.limit]))
    },
    getFileFolder (fileType) {
      const pdfs = ['application/pdf']
      let folder
      if (pdfs.includes(fileType)) {
        folder = 'app/pdf' // 文件夹名
      } else {
        folder = 'app/image' // 文件夹名
      }
      console.log(folder)
      return folder
    },
    clearFiles () {
      this.fileList = []
      this.fileNameList = []
    },
    // 压缩图片
    ImageCompressor (file) {
      let quality = this.quality
      console.log('file size', file.size)
      if (file.size < 1024 * 1024) quality = 1
      console.log('quality', quality)
      return new Promise(function (resolve, reject) {
        return new ImageCompressor(file, {
          quality: quality,
          success (result) {
            resolve(result)
          },
          error (err) {
            reject(err)
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
.el-upload--picture-card{
  position: relative;
  span{
    position: absolute;
    width: 100%;
    left: 50%;
    top: 20px;
    transform: translate(-50%)
  }

}
.upload-image{
  .el-loading-spinner{
    margin-top: 0;
  }
}
</style>
